import { StatusAnnouncer } from "../shared/components/feedback/status-announcer.js";
import { Container } from "../shared/components/layout/container.js";
import { AudioErrorDialog } from "../shared/skins/shared/audio/error-dialog.js";
import { PlaybackHotkeys } from "../shared/skins/shared/playback-hotkeys.js";
import { DefaultAudioControls } from "./controls.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/default-audio/skin.tsx
/** @jsxImportSource react */
function DefaultAudioSkin({ children, className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(Container, {
		className: cn("audio-skin", className),
		"data-theme": "default",
		"data-preset": "audio",
		...props,
		children: [
			children,
			/* @__PURE__ */ jsx(AudioErrorDialog, {}),
			/* @__PURE__ */ jsx(DefaultAudioControls, {}),
			/* @__PURE__ */ jsx(PlaybackHotkeys, {}),
			/* @__PURE__ */ jsx(StatusAnnouncer, {})
		]
	});
}
//#endregion
export { DefaultAudioSkin };

//# sourceMappingURL=skin.js.map